import React, {useEffect, useRef, useState} from 'react';
import './ImageLoader.css';
import {b64NoImage} from "./no-thumbnail";

export const ImageLoader = ({src, alt, className, loading, size, style, onClick}) => {
    // Derive size directly — no state/effect needed, avoids an extra render per card
    const imgSize = size || {width: '100%', height: 'auto'};

    const [loaded, setLoaded] = useState(false);
    // Initialise with the prop value so the first render already has the correct src.
    const [imgSrc, setImgSrc] = useState(src);

    // Ref to the <img> DOM node so we can detect cache hits (see effect below).
    const imgRef = useRef(null);

    const handleError = () => {
        setImgSrc(b64NoImage);
        setLoaded(true);
    };

    // When src changes (e.g. pagination), reset state so the new image fades in.
    useEffect(() => {
        setImgSrc(src);
        setLoaded(false);
    }, [src]);

    // Cache-hit guard: if the browser loaded the image from cache before React
    // attached the onLoad handler, img.complete is already true after the first
    // paint.  Without this check the image stays permanently blurred whenever it
    // is mounted while already cached (e.g. switching from table → grid view).
    useEffect(() => {
        const el = imgRef.current;
        if (el && el.complete && el.naturalWidth > 0) {
            setLoaded(true);
        }
    }, [imgSrc]);

    return (
        <img
            ref={imgRef}
            src={imgSrc}
            alt={alt}
            decoding="async"
            className={`loader-img ${className} ${loaded ? 'loaded' : 'loading'}`}
            onLoad={() => setLoaded(true)}
            onError={handleError}
            loading={loading || 'lazy'}
            width={imgSize.width}
            height={imgSize.height}
            style={style}
            onClick={onClick || null}
        />
    );
};
